export default "__VITE_ASSET__DW$csj$J__"